import { Box, Typography } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../../hooks/useRedux";

interface Props {
  title: string;
  active: boolean;
  index: number;
  handleClick: (index: number) => void;
}

export default function TabButton({
  title,
  active,
  index,
  handleClick,
}: Props) {
  const { themeMode } = useAppSelector((state) => state.setting);

  return (
    <Box
      onClick={() => handleClick(index)}
      sx={{
        cursor: "pointer",
        boxShadow: active ? "0px 2px 5px 0px rgba(0,0,0,0.2)" : "",
        color: active ? "primary.main" : "textColor.main",
        backgroundColor:
          themeMode === "light"
            ? active
              ? "white"
              : ""
            : active
            ? "primary.main"
            : "",
        borderRadius: "10px",
        padding: "8px 10px",
        textAlign: "center",
        transition: "background-color 0.2s",
        flex: "1",
      }}
    >
      <Typography
        sx={{
          color: themeMode === "dark" ? "#fff" : "primary.main",
        }}
        variant={active ? "body1" : "body2"}
      >
        {title}
      </Typography>
    </Box>
  );
}
